import { z } from 'zod';

/** An Enclave signing certificate, as returned by the app certs query. */
export const signingCertSchema = z.object({
  uuid: z.string(),
  name: z.string(),
  // Normalised to undefined so an absent field and an explicit null are alike
  certHash: z
    .string()
    .nullish()
    .transform((value) => value ?? undefined),
  notAfter: z
    .string()
    .nullish()
    .transform((value) => value ?? undefined),
});

export type SigningCert = z.infer<typeof signingCertSchema>;

export const appCertsResponseSchema = z.object({
  certs: z.array(signingCertSchema),
});

export const lockedCertsResponseSchema = z.array(signingCertSchema);
